/*
 * Copyright (c) 2023 Azar Aliyev
 *
 */
import debts from '@/store/modules/debts';
import Transfers from '@/store/modules/transfers';
import websocket from '@/store/modules/websocket';
import Payment from './payment';
import Favorite from './favorite';
import Autopayment from './autopayment';
import Limits from './limits';
import Automobiles from './automobiles';
import Ui from './ui';
import user from './user';

export default {
  debts,
  Payment,
  Favorite,
  Autopayment,
  Limits,
  Automobiles,
  Ui,
  user,
  Transfers,
  websocket,
};
